import {useQuery} from "@tanstack/react-query";
import {getItem} from "../../../app/getters/getItem.js";
import {useSelector} from "react-redux";

export const useProfil = (id, enabled = true) => {
    const role = useSelector(state => state.user.role);

    const isFetchingProfile = id && id !== 'nowy';
    let endpoint = '';
    let isEnabled = false;

    if (role === 'wp') {
        endpoint = `profile`;
        isEnabled = enabled && id !== 'nowy';

    } else if (role === 'oper') {
        const roleParam = 'oper';

        endpoint = isFetchingProfile
            ? `${roleParam}/profile/${id}`
            : `${roleParam}/profile`;

        isEnabled = enabled && isFetchingProfile;
    }

    return useQuery({
        queryKey: [`profil__${id}`, id, role],
        queryFn: () => getItem(endpoint),
        enabled: isEnabled,
        gcTime: 60 * 60 * 24* 1000,
        staleTime: 60 * 60 * 24* 1000,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })
}